import Backdrop from '../../../components/Backdrop';
import Box from '@material-ui/core/Box';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Slide from '@material-ui/core/Slide';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Link, useParams, useHistory, Prompt } from 'react-router-dom';
import { toast } from 'react-toastify';
import NavPrompt from '../../../components/NavPrompt';
import FilterMenu from '../../../components/FilterMenu';
import ClientModal from '../../../components/Modals/clients.js';
import api from '../../../config/api';
import { filterData } from '../../../utils/filterData';
import DataRow from './companyRow';
import CompanyProfile from './InfoPane';
import { combineNames } from '../../../utils/combineNames';
import {
	ClosePaneArrow,
	CompanyAdd,
	Delete,
	Export,
} from '../../../components/Icons/index.js';

const useStyles = makeStyles((theme) => ({
	button: {},
	content: {
		flexGrow: 1,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	contentShift: {
		marginRight: 0,
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawer: {
		flexShrink: 0,
		height: '100%',
	},
	deleteIcon: {
		padding: 0,
		marginLeft: 16,
	},
	deleteText: {
		color: theme.palette.primary.main,
	},
}));

const columns = [
	{ label: 'Name', name: 'companyName', type: 'string' },
	{ label: 'Unique Entity Number (UEN)', name: 'uen', type: 'string' },
	{ label: 'Office No', name: 'officeNo', type: 'string' },
	{ label: 'Fax No', name: 'faxNo', type: 'string' },
	{ label: 'Website', name: 'website', type: 'string' },
];

const initFilter = {
	processor: 'And',
	column: columns[0].name,
	type: columns[0].type,
	operator:
		columns[0].type === 'string' || columns[0].type === 'array'
			? 'contains'
			: '=',
	value: '',
};

export default function Companies(props) {
	let isDesktopOrLaptop = useMediaQuery({ minWidth: 768 });
	const { id } = useParams();
	const history = useHistory();
	const classes = useStyles();
	const theme = useTheme();
	const csvLink = useRef();

	const [loading, setLoading] = useState(true);
	const [open, setOpen] = useState(false);
	const [backdropOpen, setBackdropOpen] = useState(false);
	const [selectedCompany, setSelectedCompany] = useState({});

	const [companies, setCompanies] = useState([]);
	const [checkAll, setCheckAll] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const [editable, setEditable] = useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogBody, setDialogBody] = useState(0);
	const [filterList, setFilterList] = useState([initFilter]);
	const [sortOptions, setSortOptions] = useState({});
	const [viewTags, setViewTags] = useState(false);
	const [viewContacts, setViewContacts] = useState(false);
	const [triggerListUpdate, setTriggerListUpdate] = useState(true);
	const [error, setError] = useState(false);
	const [errorMessages, setErrorMessages] = useState({});

	useEffect(() => {
		if (triggerListUpdate) getCompanies();
	}, [triggerListUpdate]);

	useEffect(() => {
		if (id) {
			setOpen(true);
			setSelectedCompany(id);
			setEditable(false);
		} else {
			setOpen(false);
			setViewContacts(false);
			setSelectedCompany({});
		}
	}, [props]);

	const getCompanies = () => {
		if (!loading) {
			setLoading(true);
		}
		api
			.get('companies')
			.then((response) => {
				let bulkList = response.data
					.map((company, index) => {
						return {
							...company,
							checked: false,
						};
					})
					.sort((a, b) => {
						return new Date(b.updatedAt) - new Date(a.updatedAt);
					});
				setCompanies(bulkList);
				setTriggerListUpdate(false);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	const openPane = (e, company) => {
		let target = e.target.closest('td');
		if (target === null) {
			return;
		}
		if (target.cellIndex === 0 || target.cellIndex === undefined) {
			return;
		}
		if (target.cellIndex === 5) {
			setViewContacts(true);
		}
		history.replace(`/companies/${company._id}`);
	};

	const closePane = () => {
		history.replace(`/companies`);
	};

	const handleDelete = () => {
		setDialogOpen(false);
		setBackdropOpen(true);
		let checked = companies.filter((props) => props.checked);
		let ids = checked.map((item) => item._id);
		api.post('companies/bulk-delete', ids).then((res) => {
			if (res.data.ok) {
				toast.success('Company(s) deleted!');
				setTriggerListUpdate(true);
				setError(false);
				setErrorMessages({});
				setCheckAll(false);
				setPage(0);
				closePane();
				setBackdropOpen(false);
			} else {
				toast.error('An error has occured!');
			}
		});
	};

	const handleCancel = () => {
		setDialogOpen(false);
		closePane();
		setEditable(false);
	};

	const toggleDialog = (body) => {
		if (!dialogOpen) {
			return setDialogBody(body), setDialogOpen(true);
		}
		setDialogOpen(!dialogOpen);
	};

	const totalChecked = () => {
		return companies.filter((props) => props.checked).length;
	};

	const handleCheckAll = (e) => {
		let updatedCompanies = [...companies];
		updatedCompanies.forEach((company) => (company.checked = e.target.checked));
		setCheckAll(e.target.checked);
		setCompanies(updatedCompanies);
	};

	const handleCheckbox = (e, index) => {
		let updatedCompanies = [...companies];
		updatedCompanies.find((x) => x._id === index).checked = e.target.checked;
		setCompanies(updatedCompanies);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleSearch = (e) => {
		setPage(0);
		setSearchValue(e.target.value);
	};

	const handleClearSearch = () => {
		setPage(0);
		setSearchValue('');
	};

	const searchData = (data) => {
		if (searchValue) {
			let val = searchValue.replace(/\s+/g, ' ').toLowerCase();
			let results = data.filter((item) => {
				return Object.keys(item).some((key) => {
					if (Array.isArray(item[key]) && key === 'associatedContacts') {
						return item[key].some((x) =>
							x.contactId.firstName.toLowerCase().includes(val.toLowerCase())
						);
					} else {
						return (
							typeof item[key] === 'string' &&
							item[key].toLowerCase().includes(val.toLowerCase())
						);
					}
				});
			});
			return results;
		}
		return data;
	};

	const handleExportData = () => {
		if (filteredCompanies.length === 0) return;
		csvLink.current.link.click();
	};

	const handleSort = (key) => {
		setPage(0);
		setSortOptions((prevState) => ({ [key]: !prevState[key] }));
	};

	const sortData = (data) => {
		let sortedData = data;
		Object.keys(sortOptions).forEach((e) => {
			return sortedData.sort(compareByDesc(e, sortOptions[e]));
		});
		return sortedData;
	};

	const compareByDesc = (key, order) => {
		if (order) {
			return function (a, b) {
				if (a[key] === undefined) return 1;
				if (b[key] === undefined) return -1;
				if (a[key] === b[key]) return 0;
				return a[key].toLowerCase() < b[key].toLowerCase() ? -1 : 1;
			};
		} else {
			return function (a, b) {
				if (a[key] === undefined) return 1;
				if (b[key] === undefined) return -1;
				if (a[key] === b[key]) return 0;
				return a[key].toLowerCase() > b[key].toLowerCase() ? -1 : 1;
			};
		}
	};

	const getFilteredCompanies = () => {
		let initialList = companies;
		let sortedCompanies = sortData(initialList);
		let filteredCompanies = filterData(sortedCompanies, filterList);
		let searchedCompanies = searchData(filteredCompanies);
		return searchedCompanies;
	};

	const filteredCompanies = getFilteredCompanies();

	const emptyRows =
		rowsPerPage -
		Math.min(rowsPerPage, filteredCompanies.length - page * rowsPerPage);

	const responseList = () => {
		return filteredCompanies
			.slice(page * 10, page * 10 + 10)
			.map((currentCompany) => (
				<DataRow
					key={currentCompany._id}
					data={currentCompany}
					openPane={openPane}
					handleCheckbox={handleCheckbox}
					selected={currentCompany._id === selectedCompany}
					open={open}
				/>
			));
	};

	const generateFileName = () => {
		let generatedDate = moment(new Date()).format('DD-MM-YYYY');
		return `company-data-${generatedDate}.csv`;
	};

	const generateExportData = () => {
		let data = cloneDeep(filteredCompanies).map((row, index) => {
			delete row._id;
			delete row.createdBy;
			delete row.orgId;
			delete row.__v;
			delete row.checked;
			row.associatedContacts = row.associatedContacts.map((contact) => {
				let name = combineNames({
					fName: contact.contactId.firstName,
					mName:
						contact.contactId.middleName !== undefined
							? contact.contactId.middleName
							: null,
					lName:
						contact.contactId.lastName !== undefined
							? contact.contactId.lastName
							: null,
				});

				return `[Contact Name: ${name}, Email: ${contact.contactId.email}]`;
			});
			return row;
		});
		return data;
	};

	return (
		<>
			<NavPrompt when={editable} isRoute={false} />
			<Backdrop text='Deleting Client...' open={backdropOpen} />
			{!isDesktopOrLaptop && id ? (
				<Box style={{ width: '100%' }}>
					<Button
						style={{ marginBottom: 24 }}
						onClick={() => closePane()}
						variant='outlined'
						color='primary'
						startIcon={<NavigateBeforeIcon />}
					>
						Back
					</Button>
					{selectedCompany && (
						<div className={classes.drawer}>
							<CompanyProfile
								viewContacts={viewContacts}
								companyId={selectedCompany}
								editable={editable}
								setEditable={setEditable}
								setTriggerListUpdate={setTriggerListUpdate}
							/>
						</div>
					)}
				</Box>
			) : (
				<>
					<Breadcrumbs separator='›' aria-label='breadcrumb'>
						<Typography color='inherit'>Clients</Typography>
						<Typography color='inherit'>Companies</Typography>
						<Typography color='primary'>Company Overview</Typography>
					</Breadcrumbs>
					<Typography variant='h2' style={{ margin: '24px 0px 0px 0px' }}>
						Company Overview
					</Typography>
					<div margin='auto'>
						<div className='actionBar'>
							<Box display='flex' alignItems='center'>
								<Box>
									<Button
										component={Link}
										to={'/create-client/company'}
										color='primary'
										className={classes.button}
										startIcon={
											<CompanyAdd colorcode={theme.palette.tertiary.main} />
										}
									>
										New Company
									</Button>
								</Box>
								<Box flexGrow={1}>
									<Button
										color='primary'
										className={classes.button}
										startIcon={
											<Export colorcode={theme.palette.tertiary.main} />
										}
										onClick={() => handleExportData()}
									>
										Export Companies
									</Button>
									<CSVLink
										data={generateExportData()}
										filename={generateFileName()}
										className='hidden'
										ref={csvLink}
										target='_blank'
									/>
								</Box>
							</Box>
						</div>
						<div className='tableBar'>
							<Box display='flex' alignItems='center'>
								<Box style={{ width: 400 }}>
									<TextField
										style={{ margin: 0 }}
										value={searchValue}
										onChange={(e) => handleSearch(e)}
										placeholder='Search Companies'
										variant='filled'
										fullWidth
										margin='dense'
										InputProps={{
											startAdornment: (
												<InputAdornment
													position='start'
													style={{
														marginTop: 0,
														color: theme.palette.grey[500],
													}}
												>
													<SearchIcon />
												</InputAdornment>
											),
											endAdornment: (
												<InputAdornment position='end'>
													<IconButton
														onClick={handleClearSearch}
														disableFocusRipple
														disableRipple
														style={{
															backgroundColor: 'transparent',
															display: !searchValue && 'none',
														}}
													>
														<ClearIcon />
													</IconButton>
												</InputAdornment>
											),
										}}
									/>
								</Box>
								<Box style={{ marginLeft: 16 }}>
									<FilterMenu
										columns={columns}
										filterList={filterList}
										setFilterList={setFilterList}
									/>
								</Box>
							</Box>
						</div>
						<div className='pagination'>
							<TablePagination
								className='pagination'
								component='div'
								count={filteredCompanies.length}
								rowsPerPageOptions={[]}
								rowsPerPage={rowsPerPage}
								page={page}
								SelectProps={{
									inputProps: {
										'aria-label': 'rows per page',
									},
									native: true,
								}}
								onPageChange={handleChangePage}
							/>
						</div>
						<div
							className={clsx(classes.content, {
								[classes.contentShift]: open,
							})}
						>
							<Box
								display='flex'
								style={{
									overflow: 'auto',
									border: `1px solid ${theme.palette.grey[200]}`,
									borderRadius: 8,
								}}
							>
								<Box style={{ width: '100%' }}>
									{(totalChecked() > 0 || open) && (
										<div
											style={{
												display: 'flex',
												width: '100%',
												height: 40,
												alignItems: 'center',
												backgroundColor:
													totalChecked() > 0
														? theme.palette.tertiary.light
														: theme.palette.background.paper,
											}}
										>
											{totalChecked() > 0 && (
												<div style={{ paddingLeft: 20, display: 'flex' }}>
													<Typography
														className={classes.deleteText}
														variant='body1'
														align='left'
													>
														{totalChecked()} Selected
													</Typography>
													<IconButton
														className={classes.deleteIcon}
														onClick={() => toggleDialog(3)}
													>
														<Delete colorcode={theme.palette.text.secondary} />
													</IconButton>
												</div>
											)}
											{open && (
												<Button
													style={{ marginLeft: 'auto', marginRight: 8 }}
													onClick={() => closePane()}
													color='primary'
													endIcon={
														<ClosePaneArrow
															colorcode={theme.palette.tertiary.main}
														/>
													}
												>
													Close Details
												</Button>
											)}
										</div>
									)}
									<table className='tableContent' cellSpacing='0'>
										<thead>
											<tr
												style={{
													height: 52,
													backgroundColor: theme.palette.background.paper,
												}}
											>
												<th className='checkBox'>
													<Checkbox
														checked={checkAll}
														onChange={(e) => handleCheckAll(e)}
														inputProps={{
															'aria-label': 'primary checkbox',
														}}
													/>
												</th>
												<th onClick={() => handleSort('companyName')}>
													<div className='aligner'>
														<div className='text'>Company Name</div>
														<div className='icon'>
															{sortOptions['companyName'] ? (
																<ArrowDropUpIcon />
															) : (
																<ArrowDropDownIcon />
															)}
														</div>
													</div>
												</th>
												<th onClick={() => handleSort('uen')}>
													<div className='aligner'>
														<div className='text'>
															Unique Entity Number (UEN)
														</div>
														<div className='icon'>
															{sortOptions['uen'] ? (
																<ArrowDropUpIcon />
															) : (
																<ArrowDropDownIcon />
															)}
														</div>
													</div>
												</th>
												<th onClick={() => handleSort('officeNo')}>
													<div className='aligner'>
														<div className='text'>Office / Fax</div>
														<div className='icon'>
															{sortOptions['officeNo'] ? (
																<ArrowDropUpIcon />
															) : (
																<ArrowDropDownIcon />
															)}
														</div>
													</div>
												</th>
												<th
													style={{ display: open && 'none' }}
													onClick={() => handleSort('website')}
												>
													<div className='aligner'>
														<div className='text'>Website</div>
														<div className='icon'>
															{sortOptions['website'] ? (
																<ArrowDropUpIcon />
															) : (
																<ArrowDropDownIcon />
															)}
														</div>
													</div>
												</th>
												<th style={{ display: open && 'none' }}>
													Contact Person(s)
												</th>
												{/* <th
									style={{ display: open && 'none' }}
									onClick={() => handleSort('contacts')}
								>
									<div className='aligner'>
										<div className='text'>Contact Person(s)</div>
										<div className='icon'>
											{sortOptions['contacts'] ? (
												<ArrowDropUpIcon />
											) : (
												<ArrowDropDownIcon />
											)}
										</div>
									</div>
								</th> */}
											</tr>
										</thead>
										<tbody>
											{loading ? (
												<tr
													style={{
														height: 640,
													}}
												>
													<td
														colSpan={6}
														className='noResults'
														style={{
															textAlign: 'center',
															border: `1px solid ${theme.palette.grey[200]}`,
														}}
													>
														<CircularProgress size={80} />
													</td>
												</tr>
											) : (
												<>
													{responseList()}
													{emptyRows > 0 && emptyRows < 10 && (
														<tr
															style={{
																height: 64 * emptyRows,
															}}
														>
															<td
																colSpan={6}
																style={{
																	border: `1px solid ${theme.palette.grey[200]}`,
																}}
															/>
														</tr>
													)}
												</>
											)}
											{!filteredCompanies.length && !loading && (
												<tr
													style={{
														height: 640,
													}}
												>
													<td
														colSpan={6}
														className='noResults'
														style={{
															textAlign: 'center',
															border: `1px solid ${theme.palette.grey[200]}`,
														}}
													>
														No Results Found
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</Box>
								{open ? (
									<Box style={{ width: '100%', minWidth: 480, maxWidth: 720 }}>
										<Slide
											direction='left'
											in={open}
											mountOnEnter
											unmountOnExit
										>
											{selectedCompany && (
												<div className={classes.drawer}>
													<CompanyProfile
														viewContacts={viewContacts}
														companyId={selectedCompany}
														editable={editable}
														setEditable={setEditable}
														setTriggerListUpdate={setTriggerListUpdate}
													/>
												</div>
											)}
										</Slide>
									</Box>
								) : null}
							</Box>
						</div>
						<ClientModal
							open={dialogOpen}
							body={dialogBody}
							handleCancel={() => handleCancel()}
							handleConfirm={() => handleDelete()}
							handleClose={() => toggleDialog(0)}
						/>
					</div>
				</>
			)}
		</>
	);
}
